import { render, staticRenderFns } from "./WelcomeTwism.vue?vue&type=template&id=0f8c9be6&scoped=true&"
import script from "./WelcomeTwism.vue?vue&type=script&lang=ts&"
export * from "./WelcomeTwism.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeTwism.vue?vue&type=style&index=0&id=0f8c9be6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8c9be6",
  null
  
)

export default component.exports